// Auto-generated from live Neo4j on 2026-06-14T00:23:02.025Z
// Re-run: npm run sync-roster

export const ANCHOR_NODE = {
  name: 'Awu Chen',
  role: 'Digital Craftsman',
  title: 'MIT Media Lab RA',
  website: 'https://awuchen.github.io/',
};

export const NAME_ALIASES = {
  awu: 'Awu Chen',
  'awu chen': 'Awu Chen',
};

export const ROLES = [
  'A-C-K', 'AI researcher', 'Affiliate', 'Analyst', 'Art Advocate', 'Artist', 'Artist in Residence', 'Associate Director', 'Attendee ', 'Benrido', 'Brands And Creative Executive ', 'CEO', 'CHI 2025', 'City Science Taipei', 'Coach', 'Conference', 'Coordinator', 'Coordinator ', 'Creative ', 'Creative Director', 'Crossover Tokyo', 'Designer', 'Digital Craftsman', 'Director', 'Director, Innotech, Dhi', 'Embroidery Artist', 'Engineer', 'Entrepreneur', 'Farmoon', 'Fire-resistant button-down shirt', 'Fluid Interface', 'Founder', 'Generalist', 'HCI Researcher', 'Holder', 'Hospitality', 'Husband', 'Influencer ', 'Innovation And Technology ', 'Jc', 'Kamisoe', 'Kumie', 'Kuramonzen', 'Kyoto Research Institute', 'Lawyer', 'Lecturer Thinker', 'MIT City Science', 'Maana Homes', 'Manager', 'Mayor', 'Media Lab', 'Meteorologist', 'Mind Set Art Center', 'Model City', 'NFC', 'NFC connect', 'No.10', 'Organizer', 'Ph.D.', 'PhD candidate', 'Pommery Champagne', 'Potter', 'Pottery Craftsman', 'President', 'Principal People Business Partner', 'Principle Investigator ', 'Producer', 'Professor', 'Research & Education', 'Research Affiliate', 'Secretary of Government Technology Agency', 'Seo Marketing ', 'Small Company Doctor', 'Snow Peak', 'Somewhere In Art', 'Space Engineer', 'Speaker', 'Student', 'Student Researcher', 'Tea Caddy Craftsman', 'Technical Artist', 'Technical Producer', 'Terminal Kyoto', 'Test', 'Theatre', 'Think Tank', 'USC Network', 'Urushi Craftsman', 'Vigore', 'Visiting Researcher', 'Wasahi Craft', 'World Expo', 'affiliate', 'ambassador', 'artist', 'attendee', 'bamboo craft', 'city', 'communication', 'contemporary art & crafts', 'craftsman', 'curator', 'designer', 'eco chef', 'educator', 'engineer', 'event organizer', 'fashion', 'filmmaker', 'game dev', 'goal keeper', 'holder', 'marketing', 'mentor', 'monk', 'musician', 'new user', 'online store', 'owner', 'owner friend', 'participant', 'patron', 'producer', 'researcher', 'researcher, craftswoman ', 'startup', 'student', '盆栽家 ', '茶道',
];

export const KNOWN_USERS = [
  { name: 'Akimoto Yuji', role: 'curator', title: 'craft curator' },
  { name: 'Alex', role: 'Attendee ' },
  { name: 'Alexandra', role: 'researcher', title: 'Postdoc' },
  { name: 'Amanda', role: 'Maana Homes' },
  { name: 'Amy', role: 'Affiliate' },
  { name: 'anahita', role: 'ambassador', title: 'anahita\'s network' },
  { name: 'Andre LEE', role: 'Mind Set Art Center', title: 'Galleriest' },
  { name: 'Andrew Chen', role: 'Affiliate' },
  { name: 'Ann Liu', role: 'Art Advocate' },
  { name: 'Archer Lin', role: 'Affiliate' },
  { name: 'Arnold', role: 'owner friend' },
  { name: 'Arnold Naito', role: 'Small Company Doctor' },
  { name: 'awu', role: 'ambassador', title: 'awu\'s network' },
  { name: 'Awu Chen', role: 'Digital Craftsman', title: 'MIT Media Lab RA' },
  { name: 'Banjo', role: 'No.10', title: 'n10' },
  { name: 'Ben Lin', role: 'Brands And Creative Executive ' },
  { name: 'boston', role: 'city', title: 'boston\'s network' },
  { name: 'Boston', role: '' },
  { name: 'Bruno Olmedo Quiroga', role: 'Speaker' },
  { name: 'Charlene T', role: 'communication', title: 'communication manager' },
  { name: 'Charles Lindsay', role: 'Artist', title: 'AI artist' },
  { name: 'CHI', role: 'CHI 2025', title: 'Conference on Human Factors in Computing Systems' },
  { name: 'Chi Huang ', role: 'researcher, craftswoman ', title: '3rd generation of paper mill' },
  { name: 'Chiba Tech Symposium', role: 'Conference', title: 'Chiba Tech Symposium\'s network' },
  { name: 'Chien Ho Lin (hank)', role: 'Seo Marketing ' },
  { name: 'Chirag Sharma', role: 'Innovation And Technology ' },
  { name: 'Claire Xue', role: 'Creative ', title: 'Head of community ' },
  { name: 'Coco Capitan', role: 'Artist' },
  { name: 'Comfy', role: '', title: 'Comfyui original author' },
  { name: 'Dan Wadhwani', role: 'Director', title: 'business historian' },
  { name: 'Daniel', role: 'Affiliate' },
  { name: 'Darren Johnston', role: 'Artist in Residence', title: 'Zaha Hadid Architects' },
  { name: 'David Ling', role: 'Founder' },
  { name: 'Dechen Wangmo', role: 'Artist' },
  { name: 'Deng Nuonuo', role: 'Student' },
  { name: 'Dialogue Theatre', role: 'Theatre' },
  { name: 'eddie', role: 'ambassador', title: 'eddie\'s network' },
  { name: 'Edward Lok', role: 'affiliate', title: 'Friend / Immersive Dev' },
  { name: 'Eli', role: 'attendee' },
  { name: 'Emi Kusano', role: 'Artist', title: 'AI artist' },
  { name: 'Emily Han', role: 'Affiliate' },
  { name: 'Enrico Macciò', role: 'researcher', title: 'PhD Fellow' },
  { name: 'Erick', role: 'participant' },
  { name: 'Eugene Choi', role: 'researcher', title: 'business school professor' },
  { name: 'Felipe Arango', role: 'Founder' },
  { name: 'Ferris', role: 'ambassador', title: 'Ferris\'s network' },
  { name: 'Fire-resistant denim shirt', role: 'Snow Peak', title: 'Takibi Light Denim Utility Shirt' },
  { name: 'Frances Shi Li', role: 'Founder' },
  { name: 'Friend', role: 'affiliate' },
  { name: 'Fukutaro Nakayama', role: 'craftsman', title: 'tea master' },
  { name: 'Gal Raz', role: 'Visiting Researcher' },
  { name: 'Gary', role: 'affiliate', title: 'Aloha' },
  { name: 'Gelephu Mindfulness City', role: 'Model City' },
  { name: 'Gil Kuno', role: 'Artist', title: 'media artist' },
  { name: 'Global Innoyouth Summit', role: 'Conference' },
  { name: 'Hana Tsukamoto', role: 'Hospitality', title: 'CEO' },
  { name: 'Hannah', role: 'affiliate' },
  { name: 'Hatta Shun', role: 'craftsman', title: 'kumihimo craftsman' },
  { name: 'Hide Suzuki', role: 'A-C-K', title: 'show manager' },
  { name: 'Hikari', role: 'fashion', title: 'ambassador' },
  { name: 'Hiroshi Ishii', role: 'Principle Investigator ' },
  { name: 'homer', role: 'City Science Taipei', title: 'homer\'s network' },
  { name: 'Hope Schroeder', role: '盆栽家 ', title: 'Ripping Bonsai' },
  { name: 'Hosai Matsubayashi', role: 'Pottery Craftsman', title: 'pottery craftsman' },
  { name: 'Howard Su', role: 'Affiliate' },
  { name: 'IDEO', role: 'Think Tank' },
  { name: 'Iori', role: 'Kumie' },
  { name: 'Ishizuka Genta', role: 'Urushi Craftsman', title: 'urushi craftsman' },
  { name: 'Iwonka', role: 'Pommery Champagne', title: 'International Growth Hacking Director' },
  { name: 'Jade Huang', role: 'Artist', title: 'program manager' },
  { name: 'Janelle Wellons', role: 'Space Engineer' },
  { name: 'JB', role: '' },
  { name: 'Jedrzej Kosinski', role: 'engineer', title: 'Software Engineer' },
  { name: 'Jelly Xu', role: 'researcher' },
  { name: 'Jenny Liao', role: 'new user', title: 'Abstract Artist' },
  { name: 'Jigme Tenzing', role: 'Secretary of Government Technology Agency' },
  { name: 'Jin-Ichiro Yamada', role: 'Professor' },
  { name: 'John', role: 'Entrepreneur' },
  { name: 'John Hijika', role: 'curator', title: 'art curator' },
  { name: 'Jonny', role: 'MIT City Science', title: 'research affiliate' },
  { name: 'Jossy Lee', role: 'Founder' },
  { name: 'Judy Chang', role: 'Student' },
  { name: 'Judy Dobias', role: 'Creative Director', title: 'Boquan' },
  { name: 'Justin Chang', role: 'Affiliate' },
  { name: 'Kae Chen', role: 'marketing', title: 'Talent Agency Director' },
  { name: 'Kanta Okuda', role: 'student' },
  { name: 'Kaori Sasayama', role: 'producer', title: 'coordinator' },
  { name: 'Karl', role: 'affiliate' },
  { name: 'Karrie Karahalios', role: 'Professor' },
  { name: 'Kasper', role: 'Founder' },
  { name: 'Katherine Ma', role: 'Affiliate' },
  { name: 'Kazumasa Marayama', role: 'marketing', title: 'CEO' },
  { name: 'Kazuya Kanewaka', role: 'Artist', title: 'Nihonga painter' },
  { name: 'Kei', role: 'Crossover Tokyo', title: 'Founder' },
  { name: 'Keita Okuda', role: 'Terminal Kyoto', title: 'patron' },
  { name: 'Kelly', role: 'Organizer' },
  { name: 'Kevin Lu', role: 'Meteorologist' },
  { name: 'Kevin Scott', role: 'Potter' },
  { name: 'khoi', role: 'ambassador', title: 'khoi\'s network' },
  { name: 'Kiyomi Osawa', role: 'Embroidery Artist', title: 'embroidery artist' },
  { name: 'Ko Ishiyama', role: 'Research Affiliate' },
  { name: 'Ko Kado', role: 'Kamisoe', title: 'karakami craftsman' },
  { name: 'Kodama Kanazawa', role: 'curator', title: 'Contemporary art curator' },
  { name: 'Koh Takeuchi', role: 'AI researcher', title: 'Senior Lecturer' },
  { name: 'Koichi Saito', role: 'designer', title: 'material designer' },
  { name: 'Kurt Paulsen', role: 'affiliate', title: 'CEO sapiendra' },
  { name: 'Kutani Choemon', role: 'craftsman', title: 'pottery craftsman' },
  { name: 'Kye Shimazu', role: 'Fluid Interface' },
  { name: 'kyle', role: 'ambassador', title: 'kyle\'s network' },
  { name: 'Kyle Qian', role: 'engineer', title: 'Creative Technologist' },
  { name: 'Kyotaka Kawaguchi', role: 'Manager' },
  { name: 'Kyoto Craft Workshop', role: 'Conference', title: 'Researchers' },
  { name: 'Kyoto Startup Center', role: '' },
  { name: 'kyotographie', role: 'ambassador', title: 'kyotographie\'s network' },
  { name: 'Lei Yu', role: 'Professor' },
  { name: 'Leona Yang', role: 'Holder' },
  { name: 'Lisa Taco', role: 'Designer' },
  { name: 'Long Xiong', role: 'affiliate' },
  { name: 'Lovey', role: 'affiliate', title: 'Strategt' },
  { name: 'Lucas Huang', role: 'Affiliate' },
  { name: 'Lucy Li', role: 'PhD candidate' },
  { name: 'Maaya', role: 'Somewhere In Art' },
  { name: 'Mae Englegeer', role: 'Artist', title: 'textile artist' },
  { name: 'Margaret Minsky', role: 'Professor' },
  { name: 'Masataka Hata', role: 'President' },
  { name: 'Masataka Hosoo', role: 'Creative Director', title: 'HOSOO' },
  { name: 'Masaya Kushino', role: 'Artist', title: 'sculpture artist' },
  { name: 'Masayo Funakoshi', role: 'Farmoon', title: 'fusion chef' },
  { name: 'Matsubayashi Ashiyaka', role: 'Wasahi Craft' },
  { name: 'Matti Gruener', role: 'Affiliate' },
  { name: 'May', role: 'ambassador', title: 'May\'s network' },
  { name: 'Mei Chen', role: 'Lawyer', title: 'Lawyer' },
  { name: 'Michael Lin', role: 'City Science Taipei', title: 'Director' },
  { name: 'Midori Tsukada', role: 'Artist', title: 'glass artist' },
  { name: 'Mimi Joung', role: 'Artist' },
  { name: 'Misaki Suga', role: 'Coordinator ' },
  { name: 'MIT', role: 'Media Lab', title: 'MIT\'s network' },
  { name: 'Momoko', role: 'Kyoto Research Institute' },
  { name: 'Momoko Nakamura', role: 'Research & Education', title: 'Founding Partner' },
  { name: 'Morgan Rockett', role: 'Engineer', title: 'Fellow' },
  { name: 'Nagano Y', role: 'Benrido' },
  { name: 'Nanao Kobayashi', role: 'Artist', title: 'sound visual artist' },
  { name: 'Nanjo Kobo', role: 'craftsman', title: 'orin craftsman' },
  { name: 'Naomi Kawase', role: 'producer' },
  { name: 'nfc', role: 'ambassador', title: 'nfc\'s network' },
  { name: 'Nfc', role: 'Holder' },
  { name: 'NFC Connection', role: 'NFC', title: 'new users' },
  { name: 'Nicholas Pudjarminta', role: 'Technical Producer' },
  { name: 'Nina Fradet', role: 'Artist', title: 'bamboo artist' },
  { name: 'Ohno Kouji', role: 'Artist', title: 'curator' },
  { name: 'Oko D', role: 'Coach' },
  { name: 'Olly', role: 'Affiliate' },
  { name: 'Osaka World Expo', role: 'World Expo', title: 'Expo 2025' },
  { name: 'padlab', role: 'educator', title: 'Professor of Design' },
  { name: 'Penny & Dan', role: 'educator', title: 'PadLab' },
  { name: 'Phuntsho Namgay', role: 'Director' },
  { name: 'Phuntsho Namgayand', role: '' },
  { name: 'Quang Do', role: 'Founder' },
  { name: 'Richard Hsu', role: 'Creative Director', title: 'PoFo' },
  { name: 'Riley Shu', role: 'Generalist', title: 'Product Manager' },
  { name: 'Risa', role: 'eco chef', title: 'Risa\'s Network' },
  { name: 'Robert Mangold', role: 'Kuramonzen' },
  { name: 'Robin Bansal', role: 'Affiliate' },
  { name: 'Rocky Yang', role: 'musician', title: 'entrepreneur' },
  { name: 'Rony Kristianto ', role: 'Principal People Business Partner' },
  { name: 'Ryan Zambrano', role: 'affiliate', title: 'Founder' },
  { name: 'Ryuta Aoki', role: 'Holder' },
  { name: 'sagar', role: 'holder', title: 'artist' },
  { name: 'Saksham Consul', role: 'affiliate', title: 'Black Forest Labs (Flux)' },
  { name: 'Sample', role: 'affiliate' },
  { name: 'Samuel Mortimer', role: 'researcher' },
  { name: 'Sander Wassink', role: 'Artist', title: 'contemporary artist' },
  { name: 'Sangsun Bae', role: 'Artist' },
  { name: 'Satoko Nakasone', role: 'artist', title: 'himelli artist' },
  { name: 'Sawane', role: 'Kyoto Research Institute' },
  { name: 'Sharleen', role: '' },
  { name: 'Sheena', role: '' },
  { name: 'Shiho Fukuhara', role: 'Artist', title: 'bio artist' },
  { name: 'Shin-ichiro Masui', role: 'goal keeper', title: 'producer' },
  { name: 'shine', role: 'ambassador', title: 'shine\'s network' },
  { name: 'Shinji Ohmaki', role: 'Artist', title: 'installation artist' },
  { name: 'Shirley Huang', role: 'event organizer', title: 'PM' },
  { name: 'Shogo Okawa', role: 'Artist', title: 'Founder of Gestalt' },
  { name: 'Shuangi Tseng', role: 'Affiliate' },
  { name: 'Shuji Nakagawa', role: 'craftsman', title: 'wood craftsman' },
  { name: 'sichen', role: 'game dev' },
  { name: 'Sky Whitehead', role: 'curator', title: 'Chief Producer' },
  { name: 'Snow Peak', role: 'Fire-resistant button-down shirt', title: 'Takibi Light Denim Utility Shirt' },
  { name: 'Sol Irvine', role: 'Husband' },
  { name: 'Sola', role: 'student', title: 'TBD' },
  { name: 'Song Han', role: 'new user' },
  { name: 'Soraya Umewaka', role: 'filmmaker', title: 'founder' },
  { name: 'Sosuke', role: 'HCI Researcher' },
  { name: 'Sputniko', role: 'Artist', title: 'AI artist' },
  { name: 'Start', role: '' },
  { name: 'Stephanie Perng', role: 'affiliate', title: 'Marketing and Branding CAREhER' },
  { name: 'Suga Misaki', role: 'Coordinator' },
  { name: 'Sumith Kulal', role: 'affiliate', title: 'Black Forest Labs' },
  { name: 'Takaaki Murase', role: 'Artist', title: 'plant artist' },
  { name: 'Takafumi Zenryu Kawakami', role: 'Lecturer Thinker', title: 'Zen Priest' },
  { name: 'Takafumi%20zenryu%20kawakami  ', role: 'Holder' },
  { name: 'Takahiro Yagi', role: 'Tea Caddy Craftsman', title: 'tea caddie craftsman' },
  { name: 'Takeshi Mitani', role: 'Founder' },
  { name: 'Tanabe Chikunsai IV', role: 'craftsman', title: 'bamboo craftsman' },
  { name: 'tas', role: 'ambassador', title: 'tas\'s network' },
  { name: 'Tatsuyuki Kosuga', role: 'craftsman', title: 'bamboo craftsman' },
  { name: 'Tenshin Juba', role: 'Artist', title: 'ceramic artist' },
  { name: 'Teruri Yamawaki', role: 'Artist', title: 'ceramic artist' },
  { name: 'Thomas Lin', role: 'Affiliate' },
  { name: 'Thorneney', role: 'Affiliate' },
  { name: 'Tiffany Chou', role: 'CEO', title: 'Community Director' },
  { name: 'Tina Koyama', role: 'marketing', title: 'CEO' },
  { name: 'Toru Tsuji', role: 'craftsman', title: 'metal craftsman' },
  { name: 'Toryo Ito', role: 'monk', title: 'chief monk' },
  { name: 'Tshering Lhaden ', role: 'Influencer ' },
  { name: 'Ujjwal Deep Dahal', role: 'Affiliate' },
  { name: 'umamiboy', role: 'ambassador', title: 'umamiboy\'s network' },
  { name: 'Umamiboy', role: 'affiliate' },
  { name: 'Umi Chae', role: 'craftsman', title: 'kinkou' },
  { name: 'Una Chuang ', role: 'Affiliate' },
  { name: 'UpScaleConf', role: 'ambassador', title: 'UpScaleConf\'s network' },
  { name: 'USC', role: 'USC Network', title: 'School of Cinematic Arts' },
  { name: 'vicki', role: 'mentor', title: 'vicki\'s network' },
  { name: 'Vicki', role: 'Holder' },
  { name: 'Vishnu Bharath', role: 'Student Researcher' },
  { name: 'vivi', role: 'ambassador', title: 'vivi\'s network' },
  { name: 'Vivian Wang', role: 'patron', title: 'graphic designer ' },
  { name: 'Wangchug (dhi)', role: 'Associate Director' },
  { name: 'Wayne Chiang', role: 'Mayor' },
  { name: 'Wellington Chang', role: 'affiliate', title: 'Leasing Associate' },
  { name: 'x_x', role: '' },
  { name: 'X_X', role: 'Professor' },
  { name: 'Xu Jialin', role: 'Ph.D.' },
  { name: 'Yalu', role: 'affiliate', title: 'AI creator' },
  { name: 'Yan Naung Oak', role: 'Affiliate' },
  { name: 'Yangqi Yang', role: 'affiliate', title: '3D Designer' },
  { name: 'Yasuaki Kakehi', role: 'Professor' },
  { name: 'Yimin Zhang', role: 'Technical Artist' },
  { name: 'Yoca Muta', role: 'Artist', title: 'ceramic artist' },
  { name: 'Yoko', role: 'bamboo craft', title: 'Takano' },
  { name: 'Yoriko Ishizawa', role: 'contemporary art & crafts', title: 'creative director' },
  { name: 'Yoriko Konishi', role: '' },
  { name: 'Yoshida Shinichiro', role: 'researcher', title: 'hemp researcher' },
  { name: 'Yu Songping', role: 'researcher' },
  { name: 'Yui Kondo', role: 'designer', title: 'interior designer' },
  { name: 'Yuima Nakazato', role: 'fashion', title: 'fashion designer' },
  { name: 'Yuki Kataoka', role: 'Vigore' },
  { name: 'Yukiko Konishi', role: 'online store', title: 'founder' },
  { name: 'Yuna Yagi', role: 'Artist', title: 'photographer' },
  { name: 'Yuriko Takagi', role: 'Artist', title: 'photographer' },
  { name: 'Yusai Okuda', role: 'craftsman', title: 'dyeing craftsman' },
  { name: 'Yusan Lin', role: 'startup', title: 'CEO' },
  { name: 'Yvonne Hung', role: 'designer', title: 'founder' },
  { name: 'Zigmyal', role: 'Analyst' },
  { name: '吹田', role: 'student' },
  { name: '游牧善 Eric', role: 'Affiliate' },
  { name: '表千家', role: '茶道' },
];

export const CRAFTSMEN = KNOWN_USERS
  .filter((u) => String(u.role).toLowerCase().includes('craftsman'))
  .map((u) => u.name);

let liveRosterContext = null;

export function setRosterContext(context) {
  liveRosterContext = context;
}

export function getRosterContext() {
  if (liveRosterContext) {
    return liveRosterContext;
  }
  return {
    knownUsers: KNOWN_USERS,
    roles: ROLES,
    craftsmen: CRAFTSMEN,
    anchor: ANCHOR_NODE,
    source: 'static',
  };
}

export function formatUserRosterForPrompt(context = getRosterContext()) {
  const lines = context.knownUsers.map(
    (u) => `- ${u.name} (${u.role}${u.title ? `, ${u.title}` : ''})`
  );
  return lines.join('\n');
}

export function preprocessQuestion(question) {
  let q = question;
  q = q.replace(/\bAwu\b(?!\s+Chen\b)/gi, 'Awu Chen');
  return q;
}

export function postprocessCypher(cypher) {
  let q = cypher;
  q = q.replace(/toLower\s*\(\s*[\w.]+\.name\s*\)\s*CONTAINS\s*toLower\s*\(\s*['"]awu['"]\s*\)/gi, "a.name = 'Awu Chen'");
  q = q.replace(/toLower\s*\(\s*[\w.]+\.name\s*\)\s*CONTAINS\s*['"]awu['"]/gi, "a.name = 'Awu Chen'");
  q = q.replace(/\{\s*name\s*:\s*['"]Awu['"]\s*\}/gi, "{name: 'Awu Chen'}");
  q = q.replace(/\{\s*name\s*:\s*['"]awu['"]\s*\}/gi, "{name: 'Awu Chen'}");
  q = q.replace(/MERGE\s*\(\s*(\w+)\s*:\s*User\s*\{\s*name\s*:\s*['"]Awu['"]\s*\}\s*\)/gi, "MERGE ($1:User {name: 'Awu Chen'})");
  return q;
}

function profileScore(user) {
  let score = 0;
  if (user.role) score += 2;
  if (user.title) score += 1;
  if (user.website) score += 3;
  if (user.location) score += 1;
  if (user.name === 'Awu Chen' && String(user.website).includes('awuchen')) score += 10;
  return score;
}

function dedupeUsers(users) {
  const byName = new Map();
  users.forEach((user) => {
    const existing = byName.get(user.name);
    if (!existing || profileScore(user) > profileScore(existing)) {
      byName.set(user.name, user);
    }
  });
  return Array.from(byName.values()).sort((a, b) => a.name.localeCompare(b.name));
}

function pickAnchor(users) {
  const awuCandidates = users.filter((u) => u.name === 'Awu Chen');
  if (awuCandidates.length === 0) {
    return ANCHOR_NODE;
  }
  return awuCandidates.sort((a, b) => profileScore(b) - profileScore(a))[0];
}

function buildRosterContext(users, roles) {
  const knownUsers = dedupeUsers(users);
  const extraRoles = ['Affiliate', 'Holder', 'new user', 'NFC connect'];
  const mergedRoles = [...new Set([...roles, ...extraRoles])].sort();
  const craftsmen = knownUsers
    .filter((u) => String(u.role).toLowerCase().includes('craftsman'))
    .map((u) => u.name);

  return {
    knownUsers,
    roles: mergedRoles,
    craftsmen,
    anchor: pickAnchor(knownUsers),
  };
}

export async function fetchLiveRoster(driver) {
  const session = driver.session({ database: 'neo4j' });
  try {
    const usersRes = await session.run(`
MATCH (u:User)
WHERE u.name IS NOT NULL AND NOT u.name STARTS WITH 'User-'
RETURN u.name AS name,
       coalesce(u.role, '') AS role,
       coalesce(u.title, '') AS title,
       coalesce(u.location, '') AS location,
       coalesce(u.website, '') AS website
ORDER BY u.name
`);
    const rolesRes = await session.run(`
MATCH (u:User)
WHERE u.role IS NOT NULL AND trim(u.role) <> ''
RETURN DISTINCT u.role AS role
ORDER BY role
`);

    const rawUsers = usersRes.records.map((record) => ({
      name: record.get('name'),
      role: record.get('role') || '',
      title: record.get('title') || '',
      location: record.get('location') || '',
      website: record.get('website') || '',
    }));

    const rolesFromDb = rolesRes.records.map((record) => record.get('role'));
    const roster = buildRosterContext(rawUsers, rolesFromDb);
    const context = {
      ...roster,
      source: 'live',
      fetchedAt: Date.now(),
    };

    setRosterContext(context);
    return context;
  } finally {
    await session.close();
  }
}
